import React, { useEffect, useState, useRef } from "react";
import { Container, Button, Form, Modal, Table } from "react-bootstrap";
import { db } from "./../firebase";
import {
  collection,
  query,
  where,
  onSnapshot,
  doc,
  updateDoc,
  Timestamp,
} from "firebase/firestore";
import { postHttp } from "../api/HttpClient";
import { useAuth } from "../contexts/AuthContext";
import Navigation from "./Navigation";

export default function Admin() {
  // Get current user credentials
  const { currentUser } = useAuth();

  // States
  const [unpaidUsers, setUnpaidUsers] = useState([]);
  const [tempUser, setTempUser] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const categoryRef = useRef();
  const paymentMethodRef = useRef();

  // ===============================
  // Get Documents
  // ===============================

  // Database Queries
  const pendingUsers = query(
    collection(db, "users"),
    // where("Affiliation", "in", [
    //   "CAF",
    //   "BID",
    //   "CAF",
    //   "FES",
    //   "Swisscontact",
    //   "IISEC",
    //   "INESAD",
    //   "ABCE",
    // ]),
    where("subscription", "==", false)
    // where("category", "in", ["Expositor", "Professional"])
  );

  // where("status", "in", [0, 1, 10], "affiliation", "CAF")
  // const querySnapshot = await getDocs(currentData);

  // Hook for unpaid users
  useEffect(() => {
    const unsubscribeCollection = onSnapshot(pendingUsers, (snapshot) =>
      setUnpaidUsers(snapshot.docs.map((doc) => doc.data()))
    );
    return () => unsubscribeCollection();
  }, []);

  // ===============================
  // Functions
  // ===============================

  const paymentStatus = async (user) => {
    setLoading(true);
    const body = {
      order_owner: "Qr",
      payment_id: user.payment_id,
    };
    const docRef = doc(db, "users", user.uid);

    if (user.payment_id > 0) {
      const { response, success, errorData, message } = await postHttp(
        "verify",
        body
      );
      try {
        if (response.state === 2) {
          // Update database when QR paid
          const paymentTimeStamp = new Date(
            Timestamp.now().toDate().toString()
          );

          const dateStampUse = new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          }).format(paymentTimeStamp);

          await updateDoc(docRef, "subscription", true);
          await updateDoc(docRef, "status", response?.state);
          await updateDoc(docRef, "lastPayment", dateStampUse);

          alert("QR pagado");
        } else if (response.state === 6) {
          alert("QR vencido (codigo: 6)");

          await updateDoc(docRef, "subscription", false);
          await updateDoc(docRef, "status", 0);
          await updateDoc(docRef, "payment_id", 0);
        } else if (response.state === "98") {
          alert("QR vencido (codigo: 98)");
          await updateDoc(docRef, "subscription", false);
          await updateDoc(docRef, "status", 0);
          await updateDoc(docRef, "payment_id", 0);
        } else {
          // console.log(response);
          alert("QR pendiente");
        }
      } catch {
        // console.log('body',body)
        console.log("errorData", errorData);
        console.log("message", message);
        alert(
          "QR error:",
          "payment_id = " + body.payment_id + " did not return response"
        );
      }
    } else {
      alert("User has no active QR");

      await updateDoc(docRef, "subscription", false);
      await updateDoc(docRef, "status", 0);
      await updateDoc(docRef, "payment_id", 0);
    }

    setLoading(false);

    // console.log('error',message)
  };

  // Filter of non-becarios from unpaid users
  const noBecarios = unpaidUsers.filter((unpaidUsers) => {
    return unpaidUsers.becario !== true;
  });

  const qrUsers = unpaidUsers.filter((unpaidUsers) => {
    return unpaidUsers.paymentType === "QR" && unpaidUsers.payment_id > 0;
  });

  const nonQRUsers = unpaidUsers.filter((unpaidUsers) => {
    return unpaidUsers.status === 0;
  });

  // console.log(qrUsers);

  // ========================================
  // Function to Validate Users
  // ========================================
  async function handleValidate(e) {
    e.preventDefault();
    setLoading(true);

    // Get time Stamp
    const paymentTimeStamp = new Date(Timestamp.now().toDate().toString());

    const dateStampUse = new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(paymentTimeStamp);

    // Update document
    const docRef = doc(db, "users", tempUser.uid);
    await updateDoc(docRef, "subscription", true);
    await updateDoc(docRef, "status", 2);
    await updateDoc(docRef, "payment_id", 0);
    await updateDoc(docRef, "lastPayment", dateStampUse);
    await updateDoc(docRef, "category", categoryRef.current.value);
    await updateDoc(docRef, "paymentType", paymentMethodRef.current.value);
    await updateDoc(docRef, "validatedBy", currentUser.email);

    setLoading(false);
    setShowModal(false);
  }

  // ===============================
  // HTML
  // ===============================

  return (
    <>
      <Navigation />
      <Container
        fluid
        className="align-items-center justify-content-center mt-4"
        style={{ maxWidth: "600px" }}
      >
        {/* Modal para validar usuario */}
        <Modal
          show={showModal}
          onHide={() => {
            setShowModal(false);
          }}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title className="ms-auto">
              Validar el siguiente usuario?
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div>
              <p>
                <span className="fw-bold">Nombre completo:</span>{" "}
                {tempUser.Name + " " + tempUser.Surname}
              </p>
              <p>
                <span className="fw-bold">Afiliación:</span>{" "}
                {tempUser.Affiliation}
              </p>
              <p>
                <span className="fw-bold">Email:</span> {tempUser.email}
              </p>
              <div className="w-100 text-center mt-4">
                <Form onSubmit={handleValidate}>
                  <Form.Select aria-label="" ref={categoryRef} required>
                    <option value="">Selecciona la categoria</option>
                    <option value="Expositor">Expositor</option>
                    <option value="Professional">Professional</option>
                    <option value="Student">Student</option>
                  </Form.Select>

                  <Form.Select
                    aria-label=""
                    className="mt-3"
                    ref={paymentMethodRef}
                    required
                  >
                    <option value="">Selecciona la forma de pago</option>
                    <option value="Efectivo">Efectivo</option>
                    <option value="PayPal">PayPal</option>
                    <option value="Deposito">Deposito BISA</option>
                    <option value="Invitado">Invitado</option>
                  </Form.Select>

                  <Button className="w-100 mt-4" type="submit">
                    Validar
                  </Button>
                </Form>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* Table of status pendiente */}
      </Container>

      <div className="container">
        <h2 className="mb-4">Con QRs Pendientes</h2>

        <Table striped bordered hover>
          <thead>
            <tr>
              <th scope="col" width={"15%"}>
                Nombre
              </th>
              <th scope="col" width={"15%"}>
                Apellido
              </th>
              <th scope="col" width={"15%"}>
                Email
              </th>
              <th scope="col" width={"5%"}>
                Categoria
              </th>
              <th scope="col" width={"5%"}>
                Afiliación
              </th>

              <th scope="col" width={"10%"}>
                Accion
              </th>
              {/* <th scope="col" width={'25%'}>Validar Usuario</th> */}
            </tr>
          </thead>
          <tbody>
            {qrUsers &&
              qrUsers.map((arrayData, index) => {
                return (
                  <tr key={index}>
                    <td>{arrayData.Name}</td>
                    <td>{arrayData.Surname}</td>
                    <td>{arrayData.email}</td>
                    <td>{arrayData.category}</td>
                    <td>{arrayData.Affiliation}</td>

                    {arrayData.paymentType === "QR" && (
                      <td>
                        <Button
                          disabled={loading}
                          onClick={() => paymentStatus(qrUsers[index])}
                        >
                          Verificar QR
                        </Button>
                      </td>
                    )}
                    {/* ) : */}
                    {arrayData.paymentType !== "QR" && (
                      <td>
                        <Button
                          disabled={loading}
                          variant="success"
                          onClick={() => {
                            setTempUser(arrayData);
                            setShowModal(true);
                          }}
                        >
                          Validar Pago
                        </Button>
                      </td>
                    )}
                    {/* } */}
                    {/* { arrayData.payment_id === 0 ? (
            <td>
            <Button variant="success" onClick={() => {
              setTempUser(arrayData)
              setShowModal(true
              )}}>
               Validar
             </Button>       
            </td>) :
            <></>
          } */}
                  </tr>
                );
              })}
          </tbody>
        </Table>

        {/* Sin QR */}
        <h2 className="mb-4">Sin QRs Pendientes</h2>

        <Table striped bordered hover>
          <thead>
            <tr>
              <th scope="col" width={"15%"}>
                Nombre
              </th>
              <th scope="col" width={"15%"}>
                Apellido
              </th>
              <th scope="col" width={"15%"}>
                Email
              </th>
              <th scope="col" width={"5%"}>
                Categoria
              </th>
              <th scope="col" width={"5%"}>
                Afiliación
              </th>

              <th scope="col" width={"10%"}>
                Accion
              </th>
              {/* <th scope="col" width={'25%'}>Validar Usuario</th> */}
            </tr>
          </thead>

          <tbody>
            {/* const nonQRUsers = unpaidUsers.filter((unpaidUsers) => {
    return unpaidUsers.paymentType === null;
  }); */}

            {nonQRUsers &&
              nonQRUsers
                // .filter((ucb) => {
                //   return ucb.Affiliation === "UCB";
                // })
                .map((arrayData, index) => {
                  return (
                    <tr key={index}>
                      <td>{arrayData.Name}</td>
                      <td>{arrayData.Surname}</td>
                      <td>{arrayData.email}</td>
                      <td>{arrayData.category}</td>
                      <td>{arrayData.Affiliation}</td>

                      {/* {arrayData.paymentType === "QR" && (
                        <td>
                          <Button
                            disabled={loading}
                            onClick={() => paymentStatus(nonQRUsers[index])}
                          >
                            Verificar QR
                          </Button>
                        </td>
                      )} */}
                      {/* ) : */}
                      {arrayData.payment_id === 0 && (
                        <td>
                          <Button
                            disabled={loading}
                            variant="success"
                            onClick={() => {
                              setTempUser(arrayData);
                              setShowModal(true);
                            }}
                          >
                            Validar Pago
                          </Button>
                        </td>
                      )}
                    </tr>
                  );
                })}
          </tbody>
        </Table>
      </div>
    </>
  );
}
